@use "variables" as *;

.loginContainer {
  background-image: url(../../images/login_background.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: auto;
}

.loginContainerMinimalist {
  width: 100% !important;
  height: 100% !important;
}

.logoImage {
  filter: drop-shadow(2px 2px 2px #222);
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: $spacing-l;
  padding-bottom: $spacing-xxl;
  height: 100%;
  width: 100%;
}

.subtitle {
  font-size: $fontSize-m;
  margin-bottom: 0;
  color: white;
  font-weight: normal;
}

label {
  width: 260px;
  height: 80px;
}

button {
  background: none;
  color: white;
  border: none;
  padding: 0;
  font: inherit;
  font-size: $fontSize-xl;
  font-weight: bold;
  cursor: pointer;
  outline: inherit;
}
button:hover {
  color: lightgrey;
  transition: 0.3s;
}

.newUserButton {
  margin-top: 0;
  background: none;
  color: $mainBlue;
  border: none;
  padding: 0;
  font: inherit;
  font-size: $fontSize-m;
  font-weight: bold;
  cursor: pointer;
  outline: inherit;
}

.emailField {
  margin-top: $spacing-xl;
  height: 40px !important;
}

.submitButtonContainer {
  height: 100px;
  margin: $spacing-m;
}

.drawerButton {
  color: white;
  height: 48px;
}

.guestCard {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  margin-left: 12px;
}
.guestCardShown {
  opacity: 1;
  transition: opacity 1s ease;
}
.guestCardHidden {
  opacity: 0;
  transition: opacity 1s ease;
}

.guestArrow {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}

.credits {
  align-self: center !important;
}

.creditsMobile {
  align-self: center !important;
  padding-bottom: $spacing-g !important;
}

.creditsText {
  color: $lightgray !important;
}

.iconApple {
  width: 15px !important;
  height: 18px;
}

.emailInput {
  border-radius: 20px 20px 0 0 !important;
}

.passwordInput {
  border-radius: 0 0 20px 20px !important;
}

.googleButton {
  margin: $spacing-s;
}
